<!-- <div class="game-container">
    <div *ngIf="data" fxLayoutAdivgn="center start" fxLayout="row" class="game-grid">
        <div class="thumbnail"><img alt="{{data.name}}" src="{{ data.thumbnail?.url || data?.thumbnailDesktop?.url }}"/></div>

        <div fxLayoutAdivgn="center start" class="game-title h16">
            {{data.name}}
        </div>

        <div class="action-icon">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </div>
    </div>
</div> -->

<div class="game-card" [ngClass]="data.thumbnail?.url ? 'mobile': 'desktop'" (click)="onOpenGame(data)">
    <ng-container *ngIf="data.thumbnail?.url; else desktop">
        <div class="game-image-wrapper"  [ngClass]="{ 'bonus_exclude_overlay': isBonusExcludedGame }" >
            <img *ngIf="data.thumbnail.url" alt="{{data.name}}" src="{{ data.thumbnail.url }}" />
        </div>
    </ng-container>

    <ng-template #desktop>
        <div class="game-image-wrapper"  [ngClass]="{ 'bonus_exclude_overlay': isBonusExcludedGame }" >
        <img *ngIf="data.thumbnailDesktopSquare?.url" alt="{{data.name}}" src="{{ data.thumbnailDesktopSquare.url }}" />
        </div>
    </ng-template>
    <p style="padding-top: 0.25rem;"  [ngClass]="{ 'bonus_exclude_text': isBonusExcludedGame }">{{data.name}}</p>
    <!-- <div *ngIf="game?.tag?.includes('exclusive')" class="exclusive">
        <img src="assets/icons/tag-lemon-exclusive-desktop.svg" alt="tag-lemon-exclusive-desktop">
    </div> -->

    <div  [ngSwitch]="badge()">
        <ng-container *ngSwitchCase="'cash_drops'">
          <div class="badge">
            <img class="cash-drops" src="assets/icons/tag-thumbnail-mobile-kalamba.png">
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'drops_win'">
          <div class="badge">
            <img src="assets/icons/drops-win-icon.png">
          </div>
        </ng-container>

          <ng-container *ngSwitchCase="'take_prize'">
            <div class="take_prize">
            <img src="assets/icons/take-the-prize-mobile.png">
          </div>
          </ng-container>

        <ng-container *ngSwitchDefault>

        </ng-container>
      </div>

    <div *ngIf="data?.tag?.includes('power_weekends')" class="power-weekends">
        <img src="assets/icons/tag-power-weekends-pragmatic-desktop-2x.png">
    </div>
    <div *ngIf="data?.tag?.includes('holiday_spin_splash')" class="holiday-spin-splash">
        <img src="assets/icons/holiday-spin-splash-desktop-tag-2x.png">
    </div>
    <div *ngIf="data?.tag?.includes('spin_gifts')" class="spin_gifts">
        <img src="assets/icons/spin-gifts-desktop-60x40.png">
    </div>
    <div *ngIf="data?.tag?.includes('reel_fortune')" class="reel_fortune">
        <img src="assets/icons/ROF-desktop-52x52.png">
    </div>
    <!-- <div *ngIf="game?.uniquePlayers" fxLayout="row" fxLayoutAlign="center center" class="unique-players">
        <img src="assets/icons/icon-profile-sticky.svg" loading=lazy alt="signup" class="profile-icon" />
        <span>{{game?.uniquePlayers}}</span>
    </div> -->
    <!-- <div *ngIf="isBonusExcludedGame" [ngClass]="deviceDetect.isDesktop() ? 'bonus_exclude': 'bonus_exclude-mobile'">
        <img  src="{{licenceService.getKey('bonus-excluded')}}" alt="bonusExclude"/>
      </div> -->
      <div class="icon-tags-container">
        <div  *ngIf="isBonusExcludedGame||favouriteGame||isInTopGamesByMaxWin||isInTopGamesByTotalRounds||data.uniquePlayers" 
        [ngClass]="{ 'unique-players-icon-tags': data.uniquePlayers,
        'single_unique-players-icon-tags': !isBonusExcludedGame && !favouriteGame && !isInTopGamesByMaxWin && !isInTopGamesByTotalRounds && data.uniquePlayers}" 
        class="icon-tags">
          <div *ngIf="data?.uniquePlayers" class="unique-players">
            <img src="assets/icons/players-counter-icon.svg" loading=lazy alt="signup" class="profile-icon" />
            <span>{{data?.uniquePlayers}}</span>
          </div>
            <img  *ngIf="isBonusExcludedGame" src="{{licenceService.getKey('icon-tag-bonus-excluded')}}" alt="bonusExclude"/>
            <img *ngIf="favouriteGame" src="{{licenceService.getKey('icon-fav')}}" alt="favouriteGame"/>
            <img *ngIf="isInTopGamesByMaxWin" src="{{licenceService.getKey('icon-tag-big-win')}}" alt="bigwin">
            <img *ngIf="isInTopGamesByTotalRounds" src="{{licenceService.getKey('icon-tag-hot')}}" alt="badeHot">
        </div>
        <div *ngIf="data?.tag?.includes('exclusive')" class="exclusive">
          <img src="assets/icons/tag-lemon-exclusive-mobile.svg">
        </div>
      </div>
</div>